import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { PagedResponse } from '../types';
import { SmallBusiness } from '../types/SmallBusiness';
import { SmallBusinessFilter } from '../types/SmallBusinessFilter';

const URL = '/v2/admin/small-business';

class AdminSmallBusinessService {
  static findByFilter(
    filter: SmallBusinessFilter,
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<SmallBusiness>> {
    const params = new URLSearchParams();

    if (filter.status) params.append('status', filter.status);
    if (filter.tier) params.append('tier', filter.tier);
    if (filter.limit !== undefined) params.append('limit', String(filter.limit));

    return axios.get(`${URL}?${params.toString()}`, config);
  }

  static findByCompanyId(
    companyId: number,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<SmallBusiness | null>> {
    return axios.get(`/v2/admin/companies/${companyId}/subscription`, config);
  }
}

export { AdminSmallBusinessService };
